import api from './axios'

/**
 * Get all attachments for a contract
 * @param {number} contractId 
 * @returns {Promise<Array>}
 */
export const getAttachments = async (contractId) => {
  const response = await api.get(`/contracts/${contractId}/attachments`)
  return response.data
}

/**
 * Upload attachment to contract
 * @param {number} contractId
 * @param {File} file
 * @param {string} description
 * @param {boolean} availableToTrainer
 * @returns {Promise<object>}
 */
export const uploadAttachment = async (contractId, file, description = '', availableToTrainer = true) => {
  const formData = new FormData()
  formData.append('file', file)
  if (description) {
    formData.append('description', description)
  }
  formData.append('available_to_trainer', availableToTrainer)
  
  const response = await api.post(`/contracts/${contractId}/attachments`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
  return response.data
}

/**
 * Download attachment
 * @param {number} attachmentId 
 * @returns {Promise<Blob>}
 */
export const downloadAttachment = async (attachmentId) => {
  const response = await api.get(`/attachments/${attachmentId}/download`, {
    responseType: 'blob'
  })
  return response.data
}

/**
 * Update attachment description
 * @param {number} attachmentId 
 * @param {string} description 
 * @returns {Promise<object>}
 */
export const updateAttachment = async (attachmentId, description) => {
  const response = await api.put(`/attachments/${attachmentId}`, {
    description
  })
  return response.data
}

/**
 * Update attachment availability to trainers
 * @param {number} attachmentId
 * @param {boolean} availableToTrainer
 * @returns {Promise<object>}
 */
export const updateAttachmentAvailability = async (attachmentId, availableToTrainer) => {
  const response = await api.patch(`/attachments/${attachmentId}/availability`, {
    available_to_trainer: availableToTrainer
  })
  return response.data
}

/**
 * Delete attachment
 * @param {number} attachmentId
 * @returns {Promise<object>}
 */
export const deleteAttachment = async (attachmentId) => {
  const response = await api.delete(`/attachments/${attachmentId}`)
  return response.data
}